module.exports = __webpack_public_path__ + "static/media/coach-logo.79dd3243.svg";